import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewProgramTemplateFooterWrapper = styled.div`
  margin: 32px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: end;
  gap: 16px;
  ${responsive.MOBILE`
        margin: 0 0;
        flex-direction: column-reverse;
        padding: 16px 8px;
    
        button {
          width: 100%;
        }
    `}
`;
